import { render, staticRenderFns } from "./media-folder-data.vue?vue&type=template&id=dc3fe81c&"
import script from "./media-folder-data.vue?vue&type=script&lang=js&"
export * from "./media-folder-data.vue?vue&type=script&lang=js&"
import style0 from "./media-folder-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports